import React from 'react';
import { hideUi } from './hideUi';
import { showUi } from './showUi';

export const showUiTask = <TProps,>(Component: React.ComponentType<TProps & { close: () => void }>, props: TProps): void => {
    showUi(<Component {...props} close={() => hideUi()} />);
};
